import {
  Tooltip,
  TooltipTrigger,
  TooltipContent,
  TooltipProvider,
  TooltipArrow,
  TooltipPortal
} from "@/components/ui/tooltip";

interface AgentCardProps {
  name: string;
  language: string;
  image: string;
  isSelected: boolean;
  onClick: () => void;
  description: string;
  region: string;
}

export default function AgentCard({
  name,
  language,
  image,
  isSelected,
  onClick,
  description,
  region
}: AgentCardProps) {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <div
            className={`flex flex-col items-center py-6 rounded-2xl cursor-pointer transition-all duration-300 border-2 ${
              isSelected
                ? "border-blue-500"
                : "border-gray-200 hover:border-blue-300"
            }`}
            onClick={onClick}
          >
            <div className="w-16 h-16 rounded-full overflow-hidden mb-3">
              <img
                src={image}
                alt={name}
                className="w-full h-full object-cover"
              />
            </div>
            {/* <h4 className="font-semibold text-gray-800 text-center">{name}</h4>     */}
            <h4 className="font-semibold text-gray-800 text-center">{language}</h4>   
            {/* <p className="text-sm text-gray-600 text-center">{language}</p> */}
            <p className="text-sm text-gray-400 text-center mt-2">{region}</p>
          </div>
        </TooltipTrigger>
        <TooltipPortal>
          <TooltipContent
            side="bottom"
            className="bg-white-900 text-black px-3 py-2 rounded-lg text-sm animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 shadow-[0px_0px_12px_0px_rgba(160,160,160,0.25)] backdrop-blur-sm"
            sideOffset={5}
          >
            {description}
            <TooltipArrow className="fill-white-900" />
          </TooltipContent>
        </TooltipPortal>
      </Tooltip>
    </TooltipProvider>
  );
}
